import { useEffect, useRef } from 'react'
import { Navigation } from 'swiper'
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react'

import { Breakpoint, useCheckBreakpoint } from '~/utils'

import TutorOnDemandProductCardSlide from './components/ProductCardSlide'
import useTutorOnDemandProductCards from './TutorOnDemandProductCards.hook'

import 'swiper/swiper.min.css'
import 'swiper/swiper-bundle.min.css'

export default function TutorOnDemandProductCardsSlider({
  className = '',
  colorScheme,
  hideVideoChatWithTutor = false,
  hideChatWithTutor = false,
}: {
  className?: string
  colorScheme?: 'sky' | 'white'
  hideVideoChatWithTutor?: boolean
  hideChatWithTutor?: boolean
}): React.ReactElement {
  const config = { hideChatWithTutor, hideVideoChatWithTutor, showInSlider: true }
  const products = useTutorOnDemandProductCards(config)
  const isDesktop = useCheckBreakpoint({ gt: Breakpoint.SM })
  const swiperRef = useRef<SwiperRef | null>(null)

  useEffect(() => {
    if (isDesktop && swiperRef.current) {
      swiperRef.current.swiper.slideTo(3)
    }
  }, [isDesktop, swiperRef])

  return (
    <div className="w-full mx-auto">
      <section className={`sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl w-full mx-auto ${className}`}>
        <div className="swiper-tutor-product-container">
          <Swiper
            centeredSlides
            longSwipesMs={100}
            loop
            modules={[Navigation]}
            navigation={{
              nextEl: '.swiper-tutor-product-container .swiper-button-next',
              prevEl: '.swiper-tutor-product-container .swiper-button-prev',
            }}
            ref={swiperRef}
            slidesPerView={isDesktop ? products.length : 1}
            speed={500}
          >
            {products.map((product) => {
              return (
                <SwiperSlide className="pt-5 sm:pt-0" key={product.title}>
                  <TutorOnDemandProductCardSlide {...product} colorScheme={colorScheme} />
                </SwiperSlide>
              )
            })}
          </Swiper>
          <div className="swiper-button-prev !text-white !-left-4 sm:!-left-8 lg:!-left-12" />
          <div className="swiper-button-next !text-white !-right-4 sm:!-right-8 lg:!-right-12" />
        </div>
      </section>
    </div>
  )
}
